
import {Component, Prop, Vue} from "vue-property-decorator";
import SimpleDialog from "@/components/SimpleDialog.vue";
import {Getter} from "vuex-class";

@Component({
    components: {
        SimpleDialog,
    },
})

export default class ActivateFollowAllKeys extends Vue {

@Getter private currentUser: any;
private showDialog: boolean = false;
private switchStateInDatabase: boolean = false;
private showDialogFollowAllKeys: boolean = false;
private switchState: boolean = false;

private change() {
    if (this.switchState && !this.switchStateInDatabase) {
        this.showDialog = true;
        this.showDialogFollowAllKeys = false;
    } else if (!this.switchState && this.switchStateInDatabase) {
        this.showDialogFollowAllKeys = true;
    } else {
        this.showDialogFollowAllKeys = false;
    }
}
private getFollowAllKeysStatus() {
    this.switchStateInDatabase = this.currentUser.followAllKeys;
    this.switchState = this.currentUser.followAllKeys;
}
private mounted() {
    this.getFollowAllKeysStatus();
}
private async confirm(): Promise<void> {
    return await this.$store.dispatch("users/changeFollowAllKeys", {
            id: this.currentUser.id,
            followAllKeys : this.switchState,
        }).then(() => {
            this.$store.commit("alerts/displaySuccess", {
                msg: this.showDialog ? this.$i18n?.t("key.followAllActivatedAlert")
                : this.$i18n?.t("key.followAllDeactivatedAlert"),
            });
        }).catch((err) => {
            this.$store.commit("alerts/displayError", { msg: err });
       })
        .finally(() => {
            this.showDialog = false;
            this.showDialogFollowAllKeys = false;

            // TODO : Enlever et faire un refresh propre
            this.currentUser.followAllKeys = this.switchState;
            this.getFollowAllKeysStatus();

            // this.$store.dispatch("oauth/userByCurrentToken")
            //   .finally(() => {
            //     this.getFollowAllKeysStatus();
            // });
        });
}

private cancel() {
    this.showDialogFollowAllKeys = false;
    this.switchState = true;
}

}
